import { CREATE_FEEDBACK_COMPLETE, CREATE_FEEDBACK } from "./types";
import { createFeedbackService } from "./api";
import { toast } from "react-toastify";

export const createFeedbackAction = (payload) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_FEEDBACK });
    await createFeedbackService(payload);
    dispatch({ type: CREATE_FEEDBACK_COMPLETE });
    toast.success("Your feedback has been sent. Thank you");
  } catch (error) {
    const payload =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message;
    dispatch({ type: CREATE_FEEDBACK_COMPLETE });
    toast.error(
      payload ||
        "Hi, an error occurred, so we could not submit your feedback at the moment."
    );
  }
};
